module.exports = __webpack_public_path__ + "img/inteligencia-de-carbono.94441bef.svg";